export enum Operator {
    Filter = 'filter',
    Find = 'find',
    Map = 'map',
    Sort = 'sort'
}
